<vt-styled-authorization-page [content]="resetPasswordForm"></vt-styled-authorization-page>

<ng-template #resetPasswordForm>
  <vt-reset-password-form (submitted)="onSubmit($event)"></vt-reset-password-form>
</ng-template>